import { markdownToHtml } from "../../utils/markdownToHtml";
import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les articles de blog
export const getArticles = async (locale) => {
  // Populate explicite pour les relations imbriquées (authorBlog.avatar)
  return getWithLocaleFallback("/articles?populate[Image][populate]=*&populate[authorBlog][populate]=*&populate[blog_category][populate]=*", {
    locale,
    fallbackLocale: 'fr'
  });
};

// Fonction pour formater les articles de blog
export const formatArticles = (articlesData) => {
  if (!Array.isArray(articlesData)) {
    articlesData = [articlesData];
  }

  return articlesData.map((item) => {
    const attributes = item.attributes || item;

    // Extract image URL with multiple fallback strategies
    let imageUrl = "";
    if (attributes.Image?.data?.attributes?.url) {
      const url = attributes.Image.data.attributes.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.Image?.data?.url) {
      const url = attributes.Image.data.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.Image?.url) {
      const url = attributes.Image.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    }

    const author =
      attributes.authorBlog?.data?.attributes ||
      attributes.authorBlog || {
        name: "Admin",
        avatar: "https://via.placeholder.com/150",
      };

    // Extract author avatar URL with multiple fallback strategies
    let authorAvatarUrl = "";
    if (author.avatar?.data?.attributes?.url) {
      const url = author.avatar.data.attributes.url;
      authorAvatarUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (author.avatar?.data?.url) {
      const url = author.avatar.data.url;
      authorAvatarUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (author.avatar?.url) {
      const url = author.avatar.url;
      authorAvatarUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (typeof author.avatar === "string") {
      authorAvatarUrl = author.avatar;
    }

    const category =
      attributes.blog_category?.data?.attributes?.Title ||
      attributes.blog_category?.Title ||
      "Uncategorized";

    const calculateReadingTime = (text) => {
      if (!text) return "1 min read";

      const plainText = text.replace(/<[^>]*>/g, " ");
      const wordsPerMinute = 200;
      const wordCount = plainText
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
      const readingTimeInMinutes = Math.ceil(wordCount / wordsPerMinute);

      return `${readingTimeInMinutes} min read`;
    };

    const tags =
      attributes.tags?.data?.map(
        (tag) => tag.attributes?.name || tag.name || ""
      ) || (Array.isArray(attributes.tags) ? attributes.tags : []);

    let content = attributes.content || "";
    if (
      content &&
      typeof content === "string" &&
      (content.includes("# ") ||
        content.includes("**") ||
        content.includes("* ") ||
        content.includes("> "))
    ) {
      content = markdownToHtml(content);
    }

    return {
      id: item.id,
      title: attributes.title || attributes.Title || attributes.name || "",
      excerpt:
        attributes.excerpt || attributes.smallDescription || attributes.description || "",
      content,
      image: imageUrl,
      date: attributes.date || attributes.publishedAt || attributes.createdAt || "",
      author: {
        name: author.name || "Admin",
        avatar: authorAvatarUrl || "https://via.placeholder.com/150",
        role: author.role || "",
      },
      category,
      slug: attributes.slug || item.id?.toString() || "",
      readTime: calculateReadingTime(attributes.content || attributes.excerpt || ""),
      isPopular: attributes.popularBoolean || false,
      tags,
    };
  });
};
